export default interface IAutoDeleteSettings {
    id: string;
    frequency: number;
    frequencyId: string;
    selectedFrequencyType: string | null;
    autoDeleteTimingInHours: string;
    autoDeleteTimingInMinutes: string;
    autoDeleteInterval: number;
    autoDeleteIntervalId: string;
    selectedAutoDeleteInterval: string | null;
    isAutoDeleteOn: boolean;
    samplesLastDeletedOn: string;
}

export class AutoDeleteSettings implements IAutoDeleteSettings {
    id: string;
    frequency: number;
    frequencyId: string;
    selectedFrequencyType: string | null;
    autoDeleteTimingInHours: string;
    autoDeleteTimingInMinutes: string;
    autoDeleteInterval: number;
    autoDeleteIntervalId: string;
    selectedAutoDeleteInterval: string | null;
    isAutoDeleteOn: boolean;
    samplesLastDeletedOn: string;

    constructor(
        id: string,
        frequency: number,
        frequencyId: string,
        selectedFrequencyType: string | null,
        autoDeleteTimingInHours: string,
        autoDeleteTimingInMinutes: string,
        autoDeleteInterval: number,
        autoDeleteIntervalId: string,
        selectedAutoDeleteInterval: string | null,
        isAutoDeleteOn: boolean,
        samplesLastDeletedOn: string
    ) {
        this.id = id;
        this.frequency = frequency;
        this.frequencyId = frequencyId;
        this.selectedFrequencyType = selectedFrequencyType;
        this.autoDeleteTimingInHours = autoDeleteTimingInHours;
        this.autoDeleteTimingInMinutes = autoDeleteTimingInMinutes;
        this.autoDeleteInterval = autoDeleteInterval;
        this.autoDeleteIntervalId = autoDeleteIntervalId;
        this.selectedAutoDeleteInterval = selectedAutoDeleteInterval;
        this.isAutoDeleteOn = isAutoDeleteOn;
        this.samplesLastDeletedOn = samplesLastDeletedOn;
    }
}

const defaultAutoDeleteSettingsData = new AutoDeleteSettings("", 0, "", null, "", "", 0, "", null, false, "");
export { defaultAutoDeleteSettingsData }